import React from 'react'
import Skeleton from 'react-loading-skeleton'

const FundingSliderSkeleton = () => {
    return (
        <>
            <div className='bg-white rounded w-100 py-1 px-2 mb-4'>
                <div className='py-4 px-4'>
                    <div>
                        <Skeleton
                            width={`100%`}
                            height={50}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className=''
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default FundingSliderSkeleton
